// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-relationInformationList":"jobSearchDetail-relationInformationList"};